
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M87.407 100.199v51.267h21.037v-51.282h13.938c.595-5.83 1.189-11.464 1.79-17.338h-15.778V72.584c0-4.302 1.427-5.685 5.773-5.685 3.246-.022 6.52 0 9.7 0V49.561c-6.266 0-12.373-.29-18.444.08-4.687.283-9.142 1.854-12.561 5.352-4.028 4.106-5.223 9.364-5.491 14.832-.174 4.287-.03 8.604-.03 13.123H76.824v17.25h10.584zM102.7 6c23.783.34 46.262 9.408 64.62 27.687 18.378 18.286 27.716 40.903 27.68 66.75-.058 25.87-9.316 48.465-27.775 66.903-18.408 18.374-40.952 27.557-66.75 27.66-23.978.1-45.349-8.026-63.185-24.3-21.573-19.625-32.135-44.328-31.237-73.398C7.523 48.004 47.396 6.312 102.7 6z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    